<template>
  <a-modal :open="open" @cancel="closeForm" :style="isMobile ? modalMobileStyleObject : ''" :footer="null" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Добавление сотрудников</h2>
    </div>

    <a-divider style="margin: 16px 0" />

    <div>
      <div class="modal-no-padding__body">
        <div v-if="!showResult" class="segment-wrapper">
          <a-segmented v-model:value="currentType" :options="type" />
        </div>
      </div>

      <div v-if="!showResult">

        <div class="modal-no-padding__body">
          <a-form  name="createUser" layout="vertical" :model="createUserForm" @finish="createUser">

            <div v-if="currentType === 'Один сотрудник'">
              <div class="form-group-row">
                <a-form-item label="Имя" class="input-form-item"
                             name="first_name"
                             :rules="[{ required: true, message: 'Введите имя' }]"
                >
                  <a-input name="first_name" v-model:value="createUserForm.first_name" style="min-width: 50%"/>
                </a-form-item>

                <a-form-item label="Фамилия" class="input-form-item">
                  <a-input v-model:value="createUserForm.last_name" />
                </a-form-item>
              </div>

              <div class="form-group-row">
                <a-form-item label="Отчество" class="input-form-item">
                  <a-input v-model:value="createUserForm.patronymic" />
                </a-form-item>

                <a-form-item label="Почта" class="input-form-item"   name="email" :rules="[{ required: true, message: 'Введите почту' }]">
                  <a-input name="email" v-model:value="createUserForm.email" placeholder="Почта" :status="statusError.email ? 'error' : ''" />
                  <span v-if="statusError.email">
                  Сотрудник с таким email уже существует в системе
                </span>
                </a-form-item>
              </div>

              <div class="form-group-row">
                <a-form-item label="Должность" class="input-form-item">
                  <a-input v-model:value="createUserForm.job_title" placeholder="Название должности" />
                </a-form-item>
                <a-form-item label="Отдел" class="input-form-item">
                  <a-select
                      v-model:value="departmentValue"
                      mode="tags"
                      :options="staffDepartments"
                      placeholder="Название отдела"
                      :max-tag-count="1"
                      @change="onDepartmentChange"
                  />
                </a-form-item>
              </div>
            </div>

            <a-form-item label="Группа">
              <a-select
                  v-model:value="createUserForm.groups"
                  mode="multiple"
                  :placeholder="'Не выбрано'"
                  :not-found-content="'Нет данных'"
                  :loading="groupsLoading"
              >
                <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
                  {{ e.name }}
                </a-select-option>
              </a-select>

              <a-button type="text" class="add-group-button" v-if="!showNewGroupForm" @click="showNewGroupForm = true">
                <template #icon>
                  <PlusOutlined />
                </template>
                Создать группу
              </a-button>

              <a-row v-if="showNewGroupForm">
                <div class="group-form">
                  <div class="group-name-input">
                    <a-input v-model:value="newGroupName" placeholder="Название группы" />
                  </div>
                  <a-button :disabled="newGroupIsBeingCreated || !newGroupName" class="group-create-button primary-button" @click="createGroup">
                    Создать
                  </a-button>
                  <a-button @click="showNewGroupForm = false" class="secondary-button">
                    <template #icon>
                      <CloseOutlined />
                    </template>
                  </a-button>
                </div>
              </a-row>
            </a-form-item>

            <a-form-item>
              <div class="reset-password-form">
                <div v-if="currentType === 'Один сотрудник'">
                  <p>Пароль</p>
                  <a-radio-group class="password-radio-group" v-model:value="createUserForm.passwordType">
                    <a-radio :value="'auto'">Сгенерировать автоматически</a-radio>
                    <a-radio :value="'manual'">
                      Ввести вручную
                    </a-radio>
                  </a-radio-group>

                  <div class="password-field">
                    <a-input v-model:value="createUserForm.password" v-if="createUserForm.passwordType === 'manual'" :status="statusError.password ? 'error' : ''"/>
                    <span v-if="statusError.password">
                      Пароль должен содержать минимум 8 символов
                  </span>
                  </div>
                </div>

                <div class="checkbox-group">
                  <a-checkbox v-model:checked="createUserForm.is_active">Активировать кабинет после добавления</a-checkbox>
                  <a-checkbox v-model:checked="createUserForm.password_change_required">Обязательная смена пароля</a-checkbox>
                  <a-checkbox v-model:checked="createUserForm.send_notification">Отправить письмо с приглашением</a-checkbox>
                </div>
              </div>
            </a-form-item>

            <a-row v-if="currentType === 'Массовое добавление'">

              <a-flex class="upload-block" gap="small" vertical>
                <a
                    :href="sampleFile"
                    target="_blank"
                    download
                    class="template-link"
                >
                  Скачать excel-шаблон
                </a>

                <a-upload
                    v-if="!fileList[0]?.name"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :max-count="1"
                    :show-upload-list="false"
                    accept=".xls,.xlsx"
                >
                  <a-button :loading="fileLoading" class="secondary-button">
                    <template #icon>
                      <UploadOutlined />
                    </template>
                    {{ fileList.length ? 'Заменить' : 'Загрузить файл' }}
                  </a-button>
                </a-upload>

                <div v-else class="file-row">
                  <PaperClipOutlined />

                  <span class="file-name">
                  {{ fileList[0]?.name }}
                </span>

                  <a-upload
                      :before-upload="beforeUpload"
                      :file-list="fileList"
                      :max-count="1"
                      :show-upload-list="false"
                      accept=".xls,.xlsx"
                  >
                    <a-button type="link" class="replace-btn" :loading="fileLoading">
                      Заменить
                    </a-button>
                  </a-upload>
                </div>

                <div v-if="parsedUsers?.file_url && !fileLoading" class="after-upload">

                  <div class="result-box">
                    <CheckCircleOutlined style="color: var(--main-green)" />
                    <span>
                  Считано сотрудников: <b>{{ parsedUsers?.successful_count ?? 0 }}</b>
                </span>
                  </div>

                  <div v-if="parsedUsers?.errors_count" class="error-box">
                    <CloseCircleOutlined style="color: var(--dist-red-main)" />
                    Есть ошибки в данных: <b>{{ parsedUsers?.errors_count ?? 0 }}</b>
                  </div>

                  <a
                      :href="parsedUsers?.file_url"
                      download
                      target="_blank"
                      class="download-report"
                  >
                    Скачать отчет
                  </a>
                </div>
              </a-flex>

            </a-row>
          </a-form>
        </div>

        <a-divider/>

        <div class="modal-no-padding__footer">
          <div class="button-row">
            <a-col>
              <a-button @click="closeForm" class="secondary-button">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button @click="createUser" :disabled="currentType === 'Массовое добавление' && !parsedUsers?.successful_count" html-type="submit" class="primary-button" :loading="userFromSubmitted">Создать</a-button>
            </a-col>
          </div>
        </div>
      </div>
    </div>

    <div class="form-successful" v-if="showResult">
      <div class="modal-no-padding__body">
        <div class="successful-text">
          <template v-if="successfullySubmitted">
            <SmileOutlined class="happy-smile" />
            <div v-if="currentType === 'Массовое добавление'">
              <p>Сотрудники успешно добавлены</p>
              <span>Их можно найти на странице сотрудников</span>
            </div>
            <div v-else>
              <p>Сотрудник успешно добавлен</p>
              <span class="font-weight-normal">Его можно найти на странице сотрудников</span>
            </div>
          </template>
          <template v-if="unknownError">
            <FrownOutlined class="frown-smile" />
            <p>Ошибка добавления сотрудника</p>
            <span class="font-weight-normal">Не удалось сохранить данные. Попробуйте ещё раз или обратитесь к администратору.</span>
          </template>
        </div>
      </div>
      <a-divider/>
      <div class="modal-no-padding__footer">
        <div class="button-row">
          <a-button class="primary-button" @click="clearForm">Добавить ещё</a-button>
          <a-button class="secondary-button" @click="closeForm">Закрыть</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {MenuOutlined, PlusOutlined, ReloadOutlined, SearchOutlined, SettingOutlined, CheckCircleOutlined, PaperClipOutlined, UploadOutlined, CloseOutlined, SmileOutlined, FrownOutlined, CloseCircleOutlined} from "@ant-design/icons-vue";
import {reactive, ref, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {onBeforeMount, watch} from "@vue/runtime-core";

export default {
  name: 'new-staff-form',
  components: {SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, CheckCircleOutlined, PaperClipOutlined, UploadOutlined, CloseOutlined, SmileOutlined, FrownOutlined, CloseCircleOutlined},
  props: {
    selectedGroups: {
      type: Array,
      default: () => [],
    },
    open: Boolean,
  },
  emits: ['close', 'userCreated'],
  setup(props, context) {

    const store = useStore(),
        router = useRouter();

    const type = reactive(['Один сотрудник', 'Массовое добавление']);
    const currentType = ref('Один сотрудник');
    const allGroups = computed(() => store.state.group.groups);
    const groups = computed(() => allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        })
    );

    const showNewGroupForm = ref(false);
    const newGroupIsBeingCreated = ref(false);
    const newGroupName = ref('');
    const newCreatedGroup = computed(() => store.state.group.group);

    const staffDepartments = computed(() => store.state.users.staffDepartments.map((department) => {
      return {
        label: department,
        value: department,
      }
    }));

    const departmentOptions = [];

    const groupsLoading = ref(false);

    const fileLoading = ref(false);
    const fileResult = ref();
    const fileList = ref([]);

    const sampleFile = `${process.env.VUE_APP_BACK}/storage/user_download_example.xlsx`;
    const parsedUsers = computed(() => store.state.users.parsedUsers);

    const statusError = ref({
      password: false,
      email: null,
    });

    const createUserForm = reactive({
        first_name: null,
        patronymic: null,
        last_name: null,
        email: null,
        job_title: '',
        department: '',
        passwordType: 'auto',
        password: '',
        password_change_required: false,
        send_notification: false,
        is_active: true,
        groups: [],
        parsed_users: [],
        upload_from_parsed: false,
        role: 'staff',
    });

    const beforeUpload = async (file) => {
      userFromSubmitted.value = true;
      fileLoading.value = true

      const formData = new FormData()
      formData.append('file', file)

      store.dispatch('users/parseUsersFromExcel', formData)
        .finally(() => {
          userFromSubmitted.value = false;
          fileLoading.value = false;
      });

      fileList.value = [
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
        },
      ];

      return false
    }

    const userFromSubmitted = ref(false);
    const successfullySubmitted = ref(false);
    const unknownError = ref(false);
    const showResult = ref(false);

    const createUser = () => {
      Object.keys(statusError.value).forEach((key) => {
        statusError.value[key] = null;
      });

      if (currentType.value === 'Массовое добавление') {
         createUserForm.upload_from_parsed = true;
         createUserForm.parsed_users = parsedUsers.value.users;
         createUserForm.email = null;
         createUserForm.name = null;

         if (!parsedUsers.value?.successful_count) {
           return;
         }
      } else {
        createUserForm.upload_from_parsed = false;
        createUserForm.parsed_users = null;
      }

      userFromSubmitted.value = true;

      store.dispatch('users/createUser', {...createUserForm}).then((data) => {
        if (data?.status && data?.status === 422) {
          Object.entries(data.data).forEach(([field, messages]) => {
            statusError.value[field] = messages[0]
          });
        } else {
          context.emit('userCreated');
          clearForm();
          successfullySubmitted.value = true;
          showResult.value = true;
        }
      }).finally(() => {
          userFromSubmitted.value = false;
      });
    }

    const createGroup = () => {
      newGroupIsBeingCreated.value = true;
      store.dispatch('group/createGroup', {
        name: newGroupName.value,
      }).then(() => {
        newGroupName.value = '';
        groupsLoading.value = true;

        store.dispatch("group/getGroups").then(() => {
          groupsLoading.value = false;
          createUserForm.groups.push(newCreatedGroup.value?.group?.id);
        })
      }).finally(() => {
        newGroupIsBeingCreated.value = false;
      });
    }

    const clearForm = () => {
      Object.assign(createUserForm, {
        first_name: null,
        patronymic: '',
        last_name: '',
        email: null,
        position: '',
        department: '',
        passwordType: 'auto',
        password: '',
        password_change_required: false,
        send_notification: false,
        is_active: true,
        groups: [],
        parsed_users: null,
        upload_from_parsed: false,
        role: 'staff',
      });

      store.dispatch('users/clearParsedUsers');

      showResult.value = false;
    }

    const closeForm = () => {
      showResult.value = false;
      store.dispatch('users/clearParsedUsers');
      context.emit('close');
    }

    onBeforeMount(() => {
      store.dispatch('users/getDepartments');

      if (props.selectedGroups.length) {
        createUserForm.groups = props.selectedGroups;
      }
    });

    const departmentValue = ref();

    watch(departmentValue, (val) => {
      createUserForm.department = val[0] ?? null
    })

    const onDepartmentChange = (value) => {
      if (value.length > 1) {
        departmentValue.value = [value[value.length - 1]]
      }
    }

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    const modalMobileStyleObject = computed(() => ({
      position: 'relative',
      bottom: '0',
      top: '0',
      marginBottom: '0',
      paddingBottom: '0',
      width: '100vw',
      minWidth: '100vw',
    }));

    return {
      groups,
      createUserForm,
      type,
      currentType,
      beforeUpload,
      fileResult,
      fileList,
      fileLoading,
      sampleFile,
      groupsLoading,
      statusError,
      showNewGroupForm,
      newGroupIsBeingCreated,
      createGroup,
      newGroupName,
      departmentOptions,
      staffDepartments,
      createUser,
      departmentValue,
      onDepartmentChange,
      showResult,
      userFromSubmitted,
      successfullySubmitted,
      unknownError,
      closeForm,
      clearForm,
      parsedUsers,
      modalMobileStyleObject,
      isMobile
    }
  }
}
</script>


<style scoped lang="scss">
  .segment-wrapper {
    margin-bottom: 10px;
  }

  .form-group-row {
    display: flex;
    justify-content: space-between;
    column-gap: 10px;
    row-gap: 10px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .input-form-item {
    flex: 1;
    min-width: 0;
  }

  .add-group-button {
    padding-left: 0;
    margin-top: 10px;
    color: var(--main-green);
  }

  .group-form {
    width: 100%;
    margin-top: 10px;
    display: flex;
    column-gap: 5px;
  }

  .group-name-input {
    width: 100%;
  }

  .password-radio-group,
  .checkbox-group {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
  }

  .password-field {
    margin: 10px;
  }

  :deep(.ant-input-focused) {
    border-color: var(--main-green);
  }

  .ant-input:hover,
  .ant-input:focus {
    border-color: var(--main-green);;
  }

  .ant-input:focus,
  .ant-select-focused .ant-select-selector {
    box-shadow: 0 0 0 2px var(--polar-green);
  }

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused {
    border-color: var(--main-green);
  }

  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0 2px var(--polar-green);
  }

  .button-row {
    display: flex;
    column-gap: 10px;
    row-gap: 15px;
    justify-content: flex-end;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .successful-text {
    margin-bottom: 20px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }

  .successful-text p {
    margin-bottom: 0;
  }

  .successful-text span {
    font-size: 14px;
    color: var(--grey-text)
  }

  .successful-text .happy-smile,
  .successful-text .frown-smile {
    font-size: 65px;
  }

  .successful-text .happy-smile {
    color: var(--main-green);
  }

  .successful-text .frown-smile {
    color: var(--dist-red-main)
  }

  .replace-btn,
  .template-link {
    color: var(--neutral-text-description);
  }

  .replace-btn:hover,
  .template-link:hover {
    color: var(--main-green);
  }

  .upload-block {
    width: 100%;
  }

  .after-upload {
    padding: 15px 10px;
    background-color: var(--neutral-grey);
  }

  .error-box {
    margin-bottom: 10px;
  }

  .download-report {
    color: var(--main-green);
  }

  .download-report:hover {
    color: var(--polar-green-3)
  }

  @media (max-width: 768px) {
    .button-row button {
      width: 100%;
    }
  }

  :deep(.ant-form-item-label) {
    padding-bottom: 4px !important;
  }

  :deep(.ant-form-item) {
    margin-bottom: 12px;
  }

  :deep(.ant-btn.ant-btn-icon-only) {
    min-width: 32px;
  }
</style>